var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 4267 4267",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "svg-fill",
    d: "M4266.67 2133.335C4266.67 955.125 3311.544 0 2133.335 0 955.125 0 0 955.126 0 2133.335c0 1064.81 780.13 1947.377 1800.001 2107.418v-1490.75h-541.667v-616.668h541.667v-470c0-534.667 318.492-830.001 805.793-830.001 233.404 0 477.542 41.667 477.542 41.667v525h-269.009c-265.012 0-347.658 164.446-347.658 333.155v400.179h591.667l-94.584 616.667H2466.67v1490.751C3486.54 4080.712 4266.67 3198.144 4266.67 2133.335z",
    fill: "#fff",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.2ae66c6469280ce77e89ac4cc282c46a.svg";
export { ForwardRef as ReactComponent };